import "./App.css";
import ServerBlock from "../src/components/Server block page/components/ServerBlock";

function App() {
  console.log(process.env); // Check if REACT_APP_WEBSITE_NAME appears in the console
  return (
    <div className="App">
      <ServerBlock />
    </div>
  );
}

export default App;
